/*********************************************************************
 * The Initial Developer of the content of this file is NETCONOMY.
 * All portions of the code written by NETCONOMY are property of
 * NETCONOMY. All Rights Reserved.
 *
 * NETCONOMY Software & Consulting GmbH
 * Hilmgasse 4, A-8010 Graz (Austria)
 * FN 204360 f, Landesgericht fuer ZRS Graz
 * Tel: +43 (316) 815 544
 * Fax: +43 (316) 815544-99
 * www.netconomy.net
 *
 * (c) 2020 by NETCONOMY Software & Consulting GmbH
 *********************************************************************/

const highlighter = {
    /**
     * Used to higlight any string part with matching term.
     * Returns string with bolded matching string wrapped with HTML <b> tag.
     * @param string
     * @param term
     * @returns HTML string
     */
    highlightText: function (string, term) {
        const pattern = '(.*)(' + term.trim() + ')(.*)';
        const regex   = new RegExp(pattern, 'ig');
        return string.replace(regex, '$1<b>$2</b>$3');
    }
}

export default highlighter;